import { isSamePlatformId } from '@app/modules/social-export/domain/is-same-platform-id';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { SocialExportGetStationConnectionStateDto } from '@mi-front/api-v2';
import orderBy from 'lodash/orderBy';
import { useMemo } from 'react';
import { useStationConnections } from './useStationConnections';

/**
 * Social connections assigned to a station for a given platform,
 * ordered by lastUsedForStationAt (most recent first) for default selection and UI lists.
 */
export function useStationPlatformConnections(
  stationId: string | undefined,
  platform: SocialPlatform,
) {
  const {
    connectionsQuery,
    connections: allConnections,
    areConnectionsResolved,
  } = useStationConnections(stationId);

  const connections = useMemo((): SocialExportGetStationConnectionStateDto[] => {
    const forPlatform = allConnections.filter((item) =>
      isSamePlatformId(item.platform, platform.id),
    );

    // Prefer station-scoped usage so shared connections do not leak order across stations.
    // Coerce null to '' so never-used connections sort last under desc (lodash puts null first).
    return orderBy(forPlatform, [(c) => c.lastUsedForStationAt ?? ''], ['desc']);
  }, [allConnections, platform.id]);

  return {
    connectionsQuery,
    connections,
    areConnectionsResolved,
  };
}
